import { useNavigate } from "@tanstack/react-router";
import { usePermissions } from "@/modules/auth/presentation/model/usePermissions";
import { computeDocumentsCountSummary } from "@/modules/quotation-invoice/presentation/lib/documents-count-summary";
import { useQuotationInvoiceSummaryQuery } from "@/modules/quotation-invoice/presentation/api/queries";
import {
  DocumentsCountSummarySection,
  DocumentsCountSummarySectionSkeleton,
} from "@/modules/quotation-invoice/presentation/ui/DocumentsCountSummarySection";
import { Permissions } from "@/modules/roles/domain/contracts/permissions";
import { dashboardLayout } from "../lib/dashboard-layout";
import { DashboardSection } from "./DashboardSection";

const DASHBOARD_DOCUMENTS_GRID = "grid grid-cols-2 gap-4";
const DASHBOARD_DOCUMENTS_CARD = `${dashboardLayout.cardChrome} ${dashboardLayout.cardPad}`;

export function DashboardDocumentsPanel() {
  const { has } = usePermissions();
  const navigate = useNavigate();
  const canRead = has(Permissions.quotation_invoice.read);

  const summaryQuery = useQuotationInvoiceSummaryQuery({
    enabled: canRead,
  });
  const countSummary = computeDocumentsCountSummary(summaryQuery.data);

  if (!canRead) return null;

  return (
    <DashboardSection
      title="ເອກະສານການເງິນ"
      action={
        <button
          type="button"
          className="text-primary text-xs hover:underline"
          onClick={() => navigate({ to: "/app/documents" })}
        >
          ລາຍການທັງໝົດ →
        </button>
      }
    >
      {summaryQuery.isLoading ? (
        <DocumentsCountSummarySectionSkeleton
          gridClassName={DASHBOARD_DOCUMENTS_GRID}
          cardClassName={DASHBOARD_DOCUMENTS_CARD}
        />
      ) : (
        <DocumentsCountSummarySection
          summary={countSummary}
          gridClassName={DASHBOARD_DOCUMENTS_GRID}
          cardClassName={DASHBOARD_DOCUMENTS_CARD}
        />
      )}
    </DashboardSection>
  );
}
